import React from "react"
import SbEditable from "storyblok-react"
import { FormInfo, transformLinkUri } from "gatsby-theme-gba"
import Markdown from "react-markdown"

const FormInfoEditable = ({ blok }) => (
  <SbEditable content={blok}>
    <FormInfo>
      <Markdown
        source={blok.formInfo}
        linkTarget={url => {
          const fileExtension = url.substr(url.lastIndexOf(".") + 1)

          if (fileExtension === "pdf") {
            return "_blank"
          }

          return undefined
        }}
        transformLinkUri={uri => {
          return transformLinkUri(uri, "", blok.currentLanguage, blok.seoLinks)
        }}
      />
    </FormInfo>
  </SbEditable>
)

export default FormInfoEditable
